import { render, staticRenderFns } from "./StandalonePolicySummaryDataList.vue?vue&type=template&id=4ac9c40a"
import script from "./StandalonePolicySummaryDataList.vue?vue&type=script&lang=js"
export * from "./StandalonePolicySummaryDataList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports